// extracted by mini-css-extract-plugin
export var alertIcon = "_rk-0";